export default __webpack_public_path__ + "static/media/fanta.93dba9aa.jpg";